import { Box, Text } from '@quintoandar-tokko/jopijs';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import { PENDING_REVIEW_VIEW } from '../../constants';
import { formatPendingReviewCount } from './utils';
import { TRACK_ELEMENT } from '../../constants/track';
import styles from './pendingReview.module.scss';

function PendingReviewSummary({
  count,
  viewMode,
  onViewModeChange,
  locale,
  trackCallback = null,
}) {
  const allowedOptions = [
    {
      id: PENDING_REVIEW_VIEW.NEW,
      text: Trans(translations, 'PendingReviewNew'),
    },
    {
      id: PENDING_REVIEW_VIEW.MODIFIED,
      text: Trans(translations, 'PendingReviewModified'),
    },
  ];

  const handleClickRadio = (item) => {
    onViewModeChange(item.id);

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
    }
  };

  return (
    <Box className={styles.summaryRow}>
      <Text className={styles.count}>
        {formatPendingReviewCount(count, locale)}
      </Text>
      <RadioButtonsGroup
        className={styles.viewModeToggle}
        allowedOptions={allowedOptions}
        selectedOption={viewMode}
        onClickRadio={handleClickRadio}
      />
    </Box>
  );
}

export default PendingReviewSummary;
